import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { bem } from 'helpers/class-name';

import './RadioButton.scss';

const { block, element } = bem('hook-form-radio-button');

function RadioButton(props) {
  const {
    alignLeft,
    name,
    value,
    disabled,
    hasError,
    inline,
    flex,
    footer,
    reverse,
    validators,
    onChange = () => {},
    className,
    children,
  } = props;
  const { register } = useFormContext();
  const fieldName = `${name}.${value}`;

  const methods = register(name, {
    ...validators,
    onChange,
  });

  const Input = () => {
    if (disabled) {
      return (
        <fieldset disabled>
          <input
            type="radio"
            id={fieldName}
            data-cypress={`${name}-${value}`}
            className={element('input', { disabled, inline, reverse })}
            value={value}
            {...methods}
          />
        </fieldset>
      );
    }

    return (
      <input
        type="radio"
        id={fieldName}
        data-cypress={`${name}-${value}`}
        className={element('input', { disabled, inline, reverse })}
        value={value}
        {...methods}
      />
    );
  };

  return (
    <label htmlFor={fieldName} className={block(className)}>
      <div className={element('wrapper', { alignLeft, disabled, inline, flex, hasError, reverse })}>
        <span className={element('label', { inline, flex, reverse })}>{children}</span>
        <Input />
      </div>
      {footer}
    </label>
  );
}

RadioButton.propTypes = {
  alignLeft: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  inline: PropTypes.bool,
  flex: PropTypes.bool,
  reverse: PropTypes.bool,
  validators: PropTypes.shape({}),
  onChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default RadioButton;
